import { CustomFieldResource, CustomFieldValueAttributes } from '@/types'
import { CreateCustomFieldValueMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useQuery } from '@apollo/client'
import { CustomFieldValueOptionsQuery } from './__generated__/options_query'
import { Query as OptionsQuery } from './options_query'
import { Inline as Error } from '@/components/error'
import { Inline as Loading } from '@/components/loading'
import { valueField } from './value_field'

interface Props {
  defaultValues?: Partial<CustomFieldValueAttributes>
  onSuccess: () => void
}

export const Form = ({ defaultValues, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    attributes,
    setAttributes,
    fieldErrors
  } = useForm<CreateCustomFieldValueMutation, CustomFieldValueAttributes, never, never>({
    defaultValues: {
      customFieldId: '',
      value: '',
      resourceId: '',
      resourceType: CustomFieldResource.AssetType,
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createCustomFieldValue',
    refetchQueries: [TableQuery]
  })

  const { data, loading, error } = useQuery<CustomFieldValueOptionsQuery>(
    OptionsQuery,
    { variables: { filters: { resourceTypeEq: attributes.resourceType } } }
  )

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  if (loading) return <Loading />

  return (
    <>
      { error && <Error message={error?.message} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({
          name: 'Field',
          field: 'customFieldId',
          type: 'custom-field',
          filters: { resourceTypeEq: attributes.resourceType, availableForEq: attributes.resourceId }
        }) }
        { valueField({
          customFields: data?.customFields || { nodes: [] },
          attributes,
          setAttributes,
          fieldErrors
        }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
